"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderHashSchema = {
    id: '/OrderHashSchema',
    type: 'string',
    pattern: '^0x[0-9a-fA-F]{64}$',
};
//# sourceMappingURL=order_hash_schema.js.map